/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uno_Edu_Intro_Members_Chip1_AnswerInputs */



/**
* | output |
* | --- |
* | "An administrator invites the person from the members area and assigns a role. Enterprise organizations can also provision users automatically through SCIM." |
*
* @param {Uno_Edu_Intro_Members_Chip1_AnswerInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const uno_edu_intro_members_chip1_answer = /** @type {((inputs?: Uno_Edu_Intro_Members_Chip1_AnswerInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uno_Edu_Intro_Members_Chip1_AnswerInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Ein Administrator lädt die Person im Mitgliederbereich ein und weist eine Rolle zu. Enterprise-Organisationen können Benutzer auch automatisch über SCIM bereitstellen.")
	return /** @type {LocalizedString} */ ("An administrator invites the person from the members area and assigns a role. Enterprise organizations can also provision users automatically through SCIM.")
});